import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { NGXLogger } from "ngx-logger";
import { tap, withLatestFrom } from "rxjs/operators";
import { LocalStorageService } from "src/app/modules/local-storage/local-storage.service";
import { SideNavActions, SideNavActionTypes } from "./side-nav.actions";
import { sideNavFeatureKey, SideNavState } from "./side-nav.reducer";

@Injectable()
export class SideNavEffects {
  setExpanded$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SideNavActionTypes.SetExpanded),
        withLatestFrom(this.store),
        tap(([, state]) => {
          const sideNavStateSnapshot = state[sideNavFeatureKey];
          this.logger.debug(
            `SIDE EFFECT: persist ${sideNavFeatureKey}`,
            sideNavStateSnapshot,
          );
          this.service.persist(sideNavFeatureKey, sideNavStateSnapshot);
        }),
      ),
    { dispatch: false },
  );

  constructor(
    private actions$: Actions<SideNavActions>,
    private store: Store<{ [sideNavFeatureKey]: SideNavState }>,
    private service: LocalStorageService,
    private logger: NGXLogger,
  ) {}
}
